import type { DatovkaApiType } from '@gov-nx/api/types/databoxTypes';
import { useLocale } from '@gov-nx/core/service/translations/useLocale';
import { pipe } from '@gov-nx/core/types/pipe';
import {
	dataBoxLabel,
	getDataBoxIcon,
	useDataBoxLabel,
} from '@gov-nx/module/data-box/utils/dataBox';
import { PageCode } from '@gov-nx/module/page/definitions/codes';
import { CopyButton } from '../../Button/CopyButton';
import { Icon } from '../../Icon/Icon';
import { LayoutGap } from '../../Layout/LayoutGap';

export const DataBoxRecipientDetailContent = ({
	dataBox,
}: {
	dataBox: DatovkaApiType;
}) => {
	const { t: tn } = useLocale(PageCode['datove-schranky']);
	const { label } = useDataBoxLabel();

	return (
		<LayoutGap
			gap="m"
			className="w-full p-(--templates-margin-l) bg-(--background-block-primary) text-wrap w-[280px] [ sm:w-[400px] sm:w-auto ] [ ds:w-[280px] ds:p-6 ] [ lg:w-[380px] ] [ xl:w[400px] ]">
			<h3 className="text-body-l! text-(--text-secondary)!">
				{dataBoxLabel(dataBox, true)}
			</h3>
			<dl>
				<div className="flex items-center gap-1 text-(--text-secondary) [&:not(:last-of-type)]:mb-2">
					<dt>{tn('nova-zprava.prijemce.id-schranky')}:</dt>
					<dd>
						<strong>{dataBox.datovaSchrankaId}</strong>
					</dd>
					{dataBox.datovaSchrankaId ? (
						<CopyButton
							value={dataBox.datovaSchrankaId}
							label={tn('nova-zprava.prijemce.zkopirovat-id-schranky')}
						/>
					) : null}
				</div>
				{dataBox.ico ? (
					<div className="flex items-center gap-1 text-(--text-secondary)">
						<dt>{tn('nova-zprava.prijemce.ico')}:</dt>
						<dd>
							<strong>{dataBox.ico}</strong>
						</dd>
						<CopyButton
							value={dataBox.ico}
							label={tn('nova-zprava.prijemce.zkopirovat-ico')}
						/>
					</div>
				) : null}
			</dl>
			<div className="h-[1px] my-4 bg-(--border-subtlest) [ ds:my-6 ]" />
			<div className="flex flex-col gap-4">
				<p className="flex gap-3">
					{pipe(getDataBoxIcon(dataBox.typSchranky), (icon) =>
						icon ? (
							<Icon
								name={icon}
								type="templates"
								size="m"
								color="default"
								className="mt-1!"
							/>
						) : null
					)}
					<span className="text-(--text-primary)">
						{dataBox.typSchranky ? label(dataBox.typSchranky) : null}
					</span>
				</p>
				<p className="flex gap-3">
					<Icon
						name="geo-alt-fill"
						type="components"
						size="m"
						color="default"
						className="mt-1!"
					/>
					<span className="text-(--text-primary)">{dataBox.adresa}</span>
				</p>
			</div>
		</LayoutGap>
	);
};
